import React from 'react'
import {InputBase} from "../common";
import {useRecoilState} from 'recoil'
import {projectState} from "./atoms";

type Props = {
    type: string
    name: string
    placeholder: string
    value?: any
    disable?: boolean
}

const Input: React.FC<Props> = ({type, name, placeholder, value, disable}: Props) => {
    const [state, setState] = useRecoilState(projectState)

    return (
        <InputBase
            disabled={disable}
            value={value}
            className={'auth_input'}
            type={type}
            name={name}
            placeholder={placeholder}
            state={state}
            setState={setState}
        />
    )
}

export default Input
